




































































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import ProviderFilter from "@/components/report/filters/Providers.vue";
import StatusFilter from "@/components/report/filters/Status.vue";
import SubStatusFilter from "@/components/report/filters/SubStatus.vue";
import ApptDateFilter from "@/components/report/filters/ApptDate.vue";
import AdmissionDischargeFilter from "@/components/report/filters/AdmissionDischarge.vue";
import SelectPopover from "@/components/SelectPopover.vue";


@Component({
  components: {
    ProviderFilter,
    StatusFilter,
    SubStatusFilter,
    ApptDateFilter,
    AdmissionDischargeFilter,
    SelectPopover
  },
   computed: {
    providerFilterOn: function () {
      return this.$store.state.gaps.filter.report.providerList.length? true:false;
    },
    statusFilterOn: function () {
      return this.$store.state.gaps.filter.report.statusList.length? true:false;
    },
    subStatusFilterOn: function () {
      return this.$store.state.gaps.filter.report.subStatusList.length? true:false;
    },
    admissionDischargeFilterOn: function () {
      return this.$store.state.gaps.filter.report.admissionDischargeList.length? true:false;
    },
    apptDateFilterOn: function () {
      return this.$store.state.gaps.filter.report.apptDate.from !=null || this.$store.state.gaps.filter.report.apptDate.to != null? true:false;
    }
  }


})


export default class ApptDetailedList extends Vue {
  @Prop(Array) readonly items!: Array<any>;
  @Prop(Object) readonly filter!: Object;

  lastShownFilter!: string;
  showProviderFilter = false;
  showStatusFilter = false;
  showSubStatusFilter = false;
  showApptDateFilter = false;
  showAdmisionDischargeFilter = false;
  //insurerFilterOn = true;
  //statusFilterOn = true;
  //subStatusFilterOn = true;
  //admisionDischargeFilterOn = true;
  //referenceDateFilterOn = true;

  showHideFilter(filter: string) {
    if (this.lastShownFilter && this.lastShownFilter !== filter) {
      this.showHideFilter(this.lastShownFilter);
    }
    let show = false;
    switch (filter) {
      case "PROVIDER":
        show = !this.showProviderFilter;
        this.showProviderFilter = show;
        break;
    case "APPT_DATE":
        show = !this.showApptDateFilter;
        this.showApptDateFilter = show;
        break;
      case "STATUS":
        show = !this.showStatusFilter;
        this.showStatusFilter = show;
        break;
     case "SUB-STATUS":
        show = !this.showSubStatusFilter;
        this.showSubStatusFilter = show;
        break;
    
      case "ADMISSION_DISCHARGE":
        show = !this.showAdmisionDischargeFilter;
        this.showAdmisionDischargeFilter = show;
        break;
    }
    this.lastShownFilter = show ? filter : "";
  }

   setStatusFilter(value: number[]) {
    this.$store.commit("gaps/SET_REPORT_APPT_STATUS_FILTER", value);
  }

}
